import React from "react";

export default function Signup({ onLogin, onHome }) {
  return (
    <div dir="rtl" style={{ minHeight: "100vh", background: "#ffffff", color: "#0c1330", fontFamily: "'Cairo', sans-serif", display: "flex", flexDirection: "column" }}>
      <header style={{ display: "flex", alignItems: "center", gap: 12, padding: "16px 28px", borderBottom: "1px solid #e2e8f0" }}>
        <span onClick={onHome} style={{ display: "grid", placeItems: "center", width: 38, height: 38, background: "var(--accent, #d63a7a)", color: "#fff", fontWeight: 900, fontSize: 17, cursor: "pointer" }}>ت</span>
        <span onClick={onHome} style={{ fontSize: 17, fontWeight: 900, cursor: "pointer" }}>منصة إدارة ترجمة</span>
        <span style={{ marginInlineStart: "auto" }}>
          <button onClick={onLogin} style={{ fontFamily: "inherit", fontSize: 13.5, fontWeight: 800, padding: "9px 22px", border: "none", background: "var(--accent, #d63a7a)", color: "#fff", cursor: "pointer", borderRadius: 0 }}>تسجيل دخول</button>
        </span>
      </header>
      <main style={{ flex: 1 }}></main>
    </div>
  );
}
